import { FetchResult } from '@apollo/client'
import { RefreshCustomerTokenPayload } from 'lib/core/data/customer/tokenRefresh/types'
import { ServiceDependencies } from 'lib/core/services/magento'
import { apolloClient } from 'lib/core/services/magento/client'
import gql from 'graphql-tag'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'

export interface RefreshCustomerTokenQueryObject {
  refreshCustomerToken: {
    token: boolean
    expiration_date: boolean
    expiration_timestamp: boolean
    [key: string]: any
  }
}

export const refreshCustomerTokenQueryObject: RefreshCustomerTokenQueryObject = {
  refreshCustomerToken: {
    token: true,
    expiration_date: true,
    expiration_timestamp: true
  }
}

export type GetRefreshCustomerToken = () => Promise<FetchResult<{ refreshCustomerToken: RefreshCustomerTokenPayload }>>

export const createRefreshCustomerToken = ({ getQueries }: ServiceDependencies): GetRefreshCustomerToken => async () => {
  const query = getQueries().refreshCustomerTokenQuery

  return apolloClient.query({
    query: gql`{${jsonToGraphQLQuery(query)}}`,
    fetchPolicy: 'no-cache'
  })
}
